import React from 'react'

import Section from '../../../../../../components/Section'
import { Purchase } from '../../../types'

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchasesLoading: boolean
    purchasesError: string | null
    purchase: Purchase
    onModificationDescription: (modification_description: string) => void
    onApproveDate: (approve_date: string | null) => void
}

const PurchaseChangeInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Информация об изменении закупки">
            <fieldset disabled={props.purchaseAction}>
                <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Причина изменения информации о договоре{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={
                                props.purchase?.modification_description || ''
                            }
                            onChange={(e) =>
                                props.onModificationDescription(e.target.value)
                            }
                        />
                    </div>
                    <div className="flex flex-col">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дата утверждения изменений{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>

                        <input
                            type="date"
                            className={`form-input user-input-placeholder w-[200px]`}
                            value={props.purchase?.change_decision_date ?? ''}
                            onChange={(e) => {
                                e.target.value == ''
                                    ? props.onApproveDate(null)
                                    : props.onApproveDate(e.target.value)
                            }}
                            style={{
                                colorScheme:
                                    props.theme == 'dark' ? 'dark' : 'light',
                            }}
                        />
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default PurchaseChangeInfo
